import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Process, General } from '../redux/action/action';
import DashboardMenuComponent from '../components/DashboardMenuComponent';
import TopProcessComponent from '../components/TopProcessComponent';
import TopComponent from '../components/TopComponent';
import { Tools } from '../utils/tools';
import { Global } from '../services/Global';
import { APIS } from '../services/Config';
import ApiService from '../services/Api';
import FormFields from '../services/FormFields';

const mapStateToProps = (props) => { return { glo: props.general, pro: props.process } }
const mapDispatchToProps = (dispatch) => { return { general: (global) => dispatch(General(global)), process: (user) => dispatch(Process(user)) } }

class SpouseDataPage extends Component {
    constructor(props) {
        super(props);

        this.state = {
            program_selected: null,
            fields: FormFields.spouse_data,
            next_active: false,
            has_spouse: false,
            can_edit: true
        }
    }

    componentDidMount() {
        let _root = this;

        if (!_root.props.glo.isLogin) { window.location.href = '/'; }
        else {
            _root.setState({
                program_selected: JSON.parse(Tools.decryptrData(localStorage.getItem('app_sp'))),
                next_active: Global.formValidation('spouse_data', _root.state.fields, _root.props.pro),
                can_edit: true//(_root.props.pro.idSubmissionState >= 2) ? false : true
            });
        }

        if (_root.props.pro.noTengoConyugue === true || _root.props.pro.noTengoConyugue === 'true') {
            _root.props.pro.conyugueNombres = '';
            _root.props.pro.conyugueApellidoPaterno = '';
            _root.props.pro.conyugueApellidoMaterno = '';
            _root.props.pro.conyugueFechaNacimiento = '';
            _root.props.pro.conyugueTipoDoc = '';
            _root.props.pro.conyugueNroDocumento = '';
            _root.props.pro.conyugueTelefonoFijo = '';
            _root.props.pro.conyugueCelular = '';
            _root.props.pro.conyugueEmailPersonal = '';
            _root.props.pro.conyuguelCentroLaboral = '';
            _root.props.pro.conyugueCargo = '';
            _root.props.pro.conyugueAniosPuesto = '';
            _root.setState({
                next_active: true,
                has_spouse: true
            });
        }
    }

    onChange = e => {
        e.preventDefault();
        let _root = this;
        let _target = e.target;
        _root.props.pro[_target.name] = _target.value;

        _root.checkFields(Global.checkFormData(_target, _root.state, 'spouse_data', _root.props.pro), 'onchange');
    }

    onChangeCheck = e => {
        let _root = this;
        let _target = e.target;

        if (_target.name === 'noTengoConyugue') {
            _root.props.pro.conyugueNombres = '';
            _root.props.pro.conyugueApellidoPaterno = '';
            _root.props.pro.conyugueApellidoMaterno = '';
            _root.props.pro.conyugueFechaNacimiento = '';
            _root.props.pro.conyugueTipoDoc = '';
            _root.props.pro.conyugueNroDocumento = '';
            _root.props.pro.conyugueTelefonoFijo = '';
            _root.props.pro.conyugueCelular = '';
            _root.props.pro.conyugueEmailPersonal = '';
            _root.props.pro.conyuguelCentroLaboral = '';
            _root.props.pro.conyugueCargo = '';
            _root.props.pro.conyugueAniosPuesto = '';

            if (_target.checked) {
                _root.props.pro.noTengoConyugue = true;
                Global.removeMessageError('conyugueNombres');
                Global.removeMessageError('conyugueApellidoPaterno');
                Global.removeMessageError('conyugueNroDocumento');
                Global.removeMessageError('conyugueCelular');
                Global.removeMessageError('conyugueEmailPersonal');
                _root.setState({
                    next_active: true,
                    has_spouse: true
                });
            } else {
                _root.props.pro.noTengoConyugue = false;
                _root.setState({
                    next_active: true,
                    has_spouse: false
                })
            }
        }
    }

    // onBlur = e => {
    //     e.preventDefault();
    //     let _root = this;
    //     let _target = e.target;

    //     if (_target.name === 'conyugueCelular') {
    //         if (_target.value !== '') {
    //             if ((_target.value).length > 8) {
    //                 _root.checkFields(Global.checkFormData(_target, _root.state, 'spouse_data', _root.props.pro), 'onchange');
    //             }
    //             else {
    //                 let _prop = _root.props.pro;
    //                 let _state = _root.state;
    //                 _state.fields[_target.name].is_require = true;
    //                 _state.fields[_target.name].require_msg = 'celular mínimo 9 dígitos';
    //                 _prop[_target.name] = '';
    //                 _root.checkFields(Global.checkFormData(_target, _state, 'spouse_data', _prop), 'onchange');
    //             }
    //         }
    //         else {
    //             let _prop = _root.props.pro;
    //             let _state = _root.state;
    //             _state.fields[_target.name].is_require = false;
    //             _state.fields[_target.name].require_msg = 'celular es obligatorio';
    //             _root.checkFields(Global.checkFormData(_target, _state, 'spouse_data', _prop), 'onblur');
    //         }
    //     }
    //     else {
    //         _root.state.fields = FormFields.spouse_data;
    //         _root.checkFields(Global.checkFormData(_target, _root.state, 'spouse_data', _root.props.pro), 'onblur');
    //     }

    //     // _root.checkFields(Global.checkFormData(_target, _root.state, 'spouse_data', _root.props.pro), 'onblur');
    // }

    checkFields(state, evt) {
        let _root = this;
        let _formValidation = Global.formValidation('spouse_data', state.fields, _root.props.pro);

        _root.setState({
            fields: state.fields,
            next_active: _formValidation
        }, () => {
            if (evt === 'onblur') {
                if (_formValidation) {
                    localStorage.setItem('app_fd', Tools.cryptrData(JSON.stringify(state.fields)));
                }
            }
        });
    }

    onKeyPressInputValidate = param => (event) => {
        let _target = event.target;

        switch (_target.name) {
            case '':
                break;
            default:
                Global.onKeyPressInputValidate(event, param);
                break;
        }
    }

    onClickNext = (e) => {
        e.preventDefault();
        let _root = this;
        let _selectEntity = { ..._root.props.pro };
        if (!_root.props.pro.noTengoConyugue) {

            //#Validación de campos
            let isValidateForm = [];
            isValidateForm.push(...Global.formValidationList(FormFields.spouse_data, _selectEntity));
            if (isValidateForm.length > 0) return;

            //Custom validation
            if (_root.props.pro.conyugueNombres !== '' && !Global.validateOnlyLetter(_root.props.pro.conyugueNombres)) {
                Global.addMessageError('conyugueNombres', 'Nombre solo permite letras');
                isValidateForm.push('conyugueNombres');
            } else
                Global.removeMessageError('conyugueNombres');

            if (!Global.validateOnlyLetter(_root.props.pro.conyugueApellidoPaterno) && _root.props.pro.conyugueApellidoPaterno !== '') {
                Global.addMessageError('conyugueApellidoPaterno', 'Apellido Paterno solo permite letras');
                isValidateForm.push('conyugueApellidoPaterno');
            } else
                Global.removeMessageError('conyugueApellidoPaterno');

            if (!Global.validateOnlyLetter(_root.props.pro.conyugueApellidoMaterno) && _root.props.pro.conyugueApellidoMaterno !== '') {
                Global.addMessageError('conyugueApellidoMaterno', 'Apellido materno solo permite letras');
                isValidateForm.push('conyugueApellidoMaterno');
            }
            else
                Global.removeMessageError('conyugueApellidoMaterno');

            if (isValidateForm.length > 0) return;

            Tools.showPreloader();
            _root.props.pro.vistasCompletadas = JSON.stringify(Global.addViewComplete(_root.props.pro.vistasCompletadas, '/datos-conyuge'));
            _root.props.process(_root.props.pro);
            _root.props.general(_root.props.glo);
            ApiService.postData(`${APIS.submission}`, _root.props.pro)
                .then(res => {
                    Tools.hidePreloader();
                    _root.props.navigate('/informacion-academica');
                })
                .catch(err => {
                    Tools.hidePreloader();
                    console.log(err);
                });
        }
        else {
            Tools.showPreloader();
            _root.props.pro.conyugueFechaNacimiento = '2001-01-01'
            _root.props.pro.vistasCompletadas = JSON.stringify(Global.addViewComplete(_root.props.pro.vistasCompletadas, '/datos-conyuge'));
            _root.props.process(_root.props.pro);
            _root.props.general(_root.props.glo);
            ApiService.postData(`${APIS.submission}`, _root.props.pro)
                .then(res => {
                    Tools.hidePreloader();
                    _root.props.navigate('/informacion-academica');
                })
                .catch(err => {
                    Tools.hidePreloader();
                    console.log(err);
                });
        }
    }
    onKeyPressInputValidate = param => (event) => {
        Global.onKeyPressInputValidate(event, param);
    }
    render() {
        const {
            program_selected,
            next_active,
            has_spouse,
            can_edit
        } = this.state;

        const {
            navigate,
        } = this.props;

        return (
            <div className="container">
                <div className="row app-layout-main">
                    <div id="sidebar-dashboard" className="col-md-3 left-side-dashboard">
                        {(program_selected !== null) ? <DashboardMenuComponent navigate={navigate} step={'1'} form={program_selected.form} /> : <></>}
                    </div>
                    <div className="col-md-9 right-side-dashboard">
                        <TopProcessComponent porcent="15" />
                        <div className="row content-dashboard">
                            <div className="col-sm-12">
                                <div className="row pt-3 pb-3">
                                    <div className="col-sm-12 col-md-6"><TopComponent direction="back" label="Paso Previo" path="/datos-adicionales" /></div>
                                    <div className="col-sm-12 col-md-6">
                                        <div className="form-group pb-2">
                                        </div>
                                    </div>
                                </div>

                                <div className="row pt-2 pb-2">
                                    <div className="col-sm-12 col-md-3">
                                        <h5><strong>Datos del Cónyuge</strong></h5>
                                    </div>
                                    <div className="col-sm-12 col-md-9">
                                        <div className="form-check pb-2">
                                            <input disabled={!can_edit} className="form-check-input" type="checkbox" id="noTengoConyugue" name="noTengoConyugue" onChange={this.onChangeCheck} checked={this.props.pro.noTengoConyugue} />
                                            <label className="form-check-label" htmlFor="noTengoConyugue">No tengo Cónyuge</label>
                                        </div>
                                    </div>
                                </div>

                                <div className="row pt-2 pb-2">
                                    <div className="col-sm-12 col-md-4">
                                        <div className="form-group pb-2">
                                            <label htmlFor="conyugueNombres" className="pb-2">Nombres {(!has_spouse) && <span className="text-danger">*</span>}</label>

                                            <input disabled={!can_edit && !has_spouse} type="text" className={(has_spouse) ? 'form-control disabled' : 'form-control'} id="conyugueNombres" name="conyugueNombres"
                                                value={this.props.pro.conyugueNombres}
                                                onChange={this.onChange}
                                                aria-describedby="nameHelp"
                                                placeholder="Como figuren en el DNI" />

                                            <div className="invalid-feedback"></div>
                                        </div>
                                    </div>
                                    <div className="col-sm-12 col-md-4">
                                        <div className="form-group pb-2">
                                            <label htmlFor="conyugueApellidoPaterno" className="pb-2">Apellido Paterno {(!has_spouse) && <span className="text-danger">*</span>}</label>
                                            <input
                                                disabled={!can_edit && !has_spouse}
                                                type="text"
                                                className={(has_spouse) ? 'form-control disabled' : 'form-control'} id="conyugueApellidoPaterno"
                                                name="conyugueApellidoPaterno" value={this.props.pro.conyugueApellidoPaterno} onChange={this.onChange} aria-describedby="nameHelp" placeholder="Como figuren en el DNI" />
                                            <div className="invalid-feedback"></div>
                                        </div>
                                    </div>
                                    <div className="col-sm-12 col-md-4">
                                        <div className="form-group pb-2">
                                            <label htmlFor="conyugueApellidoMaterno" className="pb-2">Apellido Materno</label>
                                            <input disabled={!can_edit && !has_spouse} type="text" className={(has_spouse) ? 'form-control disabled' : 'form-control'} id="conyugueApellidoMaterno" name="conyugueApellidoMaterno" value={this.props.pro.conyugueApellidoMaterno} onChange={this.onChange} aria-describedby="nameHelp" placeholder="Como figuren en el DNI" />
                                            <div className="invalid-feedback"></div>
                                        </div>
                                    </div>
                                </div>

                                <div className="row pt-2 pb-2">
                                    <div className="col-sm-12 col-md-4">
                                        <div className="form-group pb-2">
                                            <label htmlFor="conyugueFechaNacimiento" className="pb-2">Fecha de Nacimiento</label>
                                            <input disabled={!can_edit && !has_spouse}
                                                type="date"
                                                className={(has_spouse) ? 'form-control disabled' : 'form-control'}
                                                id="conyugueFechaNacimiento"
                                                name="conyugueFechaNacimiento"
                                                value={this.props.pro.conyugueFechaNacimiento || ''} onChange={this.onChange} aria-describedby="nameHelp" />
                                            <div className="invalid-feedback"></div>
                                        </div>
                                    </div>
                                    <div className="col-sm-12 col-md-4">
                                        <div className="form-group pb-2">
                                            <label htmlFor="conyugueTipoDoc" className="pb-2">DNI/CE/CI</label>
                                            <select disabled={!can_edit && !has_spouse} className={(has_spouse) ? 'form-control disabled' : 'form-control'} id="conyugueTipoDoc" name="conyugueTipoDoc" onChange={this.onChange} value={this.props.pro.conyugueTipoDoc}>
                                                <option value={null} disabled>Selecciona una opción</option>
                                                {
                                                    this.props.glo.tiposDocumentoIdentidad.map((item, i) => (
                                                        <option key={(i + 1) + 'td'} value={item.id}>{item.descripcionCorta}</option>
                                                    ))
                                                }
                                            </select>
                                            <div className="invalid-feedback"></div>
                                        </div>
                                    </div>
                                    <div className="col-sm-12 col-md-4">
                                        <div className="form-group pb-2">
                                            <label htmlFor="conyugueNroDocumento" className="pb-2">Número de Documento {(!has_spouse) && <span className="text-danger">*</span>}</label>
                                            <input disabled={!can_edit && !has_spouse} type="text" className={(has_spouse) ? 'form-control disabled' : 'form-control'} id="conyugueNroDocumento" name="conyugueNroDocumento"
                                                value={this.props.pro.conyugueNroDocumento} maxLength="12" onChange={this.onChange} aria-describedby="nameHelp" />
                                            <div className="invalid-feedback"></div>
                                        </div>
                                    </div>
                                </div>

                                <div className="row pt-2 pb-2">
                                    <div className="col-sm-12 col-md-4">
                                        <div className="form-group pb-2">
                                            <label htmlFor="conyugueTelefonoFijo" className="pb-2">Teléfono Fijo (Opcional)</label>
                                            <input disabled={!can_edit && !has_spouse} maxLength="9" type="text" className={(has_spouse) ? 'form-control disabled' : 'form-control'} id="conyugueTelefonoFijo" name="conyugueTelefonoFijo" value={this.props.pro.conyugueTelefonoFijo} onChange={this.onChange} onKeyPress={this.onKeyPressInputValidate('only_number_positive')} aria-describedby="nameHelp" placeholder="(Opcional) No obligatorio" />
                                            <div className="invalid-feedback"></div>
                                        </div>
                                    </div>
                                    <div className="col-sm-12 col-md-4">
                                        <div className="form-group pb-2">
                                            <label htmlFor="conyugueCelular" className="pb-2">Celular {(!has_spouse) && <span className="text-danger">*</span>}</label>
                                            <input disabled={!can_edit && !has_spouse} maxLength="9" type="text" className={(has_spouse) ? 'form-control disabled' : 'form-control'} id="conyugueCelular" name="conyugueCelular" value={this.props.pro.conyugueCelular} onChange={this.onChange} onKeyPress={this.onKeyPressInputValidate('only_number_positive')} aria-describedby="nameHelp" />
                                            <div className="invalid-feedback"></div>
                                        </div>
                                    </div>
                                    <div className="col-sm-12 col-md-4">
                                        <div className="form-group pb-2">
                                            <label htmlFor="conyugueEmailPersonal" className="pb-2">E-mail Personal del Cónyuge {(!has_spouse) && <span className="text-danger">*</span>}</label>
                                            <input disabled={!can_edit && !has_spouse} type="email" className={(has_spouse) ? 'form-control disabled' : 'form-control'} id="conyugueEmailPersonal" name="conyugueEmailPersonal" value={this.props.pro.conyugueEmailPersonal} onChange={this.onChange} aria-describedby="nameHelp" />
                                            <div className="invalid-feedback"></div>
                                        </div>
                                    </div>
                                </div>

                                <div className="row pt-2 pb-2">
                                    <div className="col-sm-12 col-md-4">
                                        <div className="form-group pb-2">
                                            <label htmlFor="conyuguelCentroLaboral" className="pb-2">Centro Laboral</label>
                                            <input disabled={!can_edit && !has_spouse} type="text" className={(has_spouse) ? 'form-control disabled' : 'form-control'} id="conyuguelCentroLaboral" name="conyuguelCentroLaboral" value={this.props.pro.conyuguelCentroLaboral} onChange={this.onChange} aria-describedby="nameHelp" />
                                            <div className="invalid-feedback"></div>
                                        </div>
                                    </div>
                                    <div className="col-sm-12 col-md-4">
                                        <div className="form-group pb-2">
                                            <label htmlFor="conyugueCargo" className="pb-2">Cargo</label>
                                            <input disabled={!can_edit && !has_spouse} type="text" className={(has_spouse) ? 'form-control disabled' : 'form-control'} id="conyugueCargo" name="conyugueCargo" value={this.props.pro.conyugueCargo} onChange={this.onChange} aria-describedby="nameHelp" />
                                            <div className="invalid-feedback"></div>
                                        </div>
                                    </div>
                                    <div className="col-sm-12 col-md-4">
                                        <div className="form-group pb-2">
                                            <label htmlFor="conyugueAniosPuesto" className="pb-2">Años en el Puesto</label>
                                            <input 
                                            disabled={!can_edit && !has_spouse} 
                                            type="text" className={(has_spouse) ? 'form-control disabled' : 'form-control'} 
                                            id="conyugueAniosPuesto" name="conyugueAniosPuesto" value={this.props.pro.conyugueAniosPuesto} 
                                            onKeyDown={this.onKeyPressInputValidate('only_number_positive')}
                                            maxLength={2}
                                            onChange={this.onChange} aria-describedby="nameHelp" />
                                            <div className="invalid-feedback"></div>
                                        </div>
                                    </div>
                                </div>

                                <div className="row pt-2 pb-2">
                                    <div className="col-sm-12 col-md-4"></div>
                                    <div className="col-sm-12 col-md-4"></div>
                                    <div className="col-sm-12 col-md-4" style={{ textAlign: 'right' }}>
                                        <button className={(next_active) ? 'btn btn-primary btn-style-4' : 'btn btn-primary btn-style-4'} onClick={this.onClickNext}>Siguiente paso <i className="fa fa-arrow-right" aria-hidden="true"></i></button>
                                    </div>
                                </div>

                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(SpouseDataPage);